module.exports = __webpack_public_path__ + "img/success-persons.16f68e2b.svg";